<script lang="ts">
  import type { LeaderboardBoard } from '../../shared/modes';
  import Card from '../ui/Card.svelte';
  import Tabs from '../ui/Tabs.svelte';
  import RankLadder from './RankLadder.svelte';
  import ScoreLeaderboard from './ScoreLeaderboard.svelte';

  let { credential, profileGeneration }: { credential: string | null; profileGeneration: number } = $props();

  type Tab = LeaderboardBoard | 'competitive';
  const tabs: { value: Tab; label: string }[] = [
    { value: 'today', label: 'Today' },
    { value: 'competitive', label: 'Competitive' },
    { value: 'all-time', label: 'All-Time' },
  ];
  let selected = $state<Tab>('today');
</script>

<Card>
  <Tabs bind:value={selected} items={tabs} label="Leaderboard selection">
    {#snippet children(tab)}
      {#if tab === 'competitive'}
        <RankLadder {credential} {profileGeneration} />
      {:else}
        <ScoreLeaderboard board={tab} {credential} {profileGeneration} />
      {/if}
    {/snippet}
  </Tabs>
</Card>
